import { React } from 'react';

function Footer() {
    return (
        <footer>
            <div class="container">
                <div class="col-md-4 text-center">
                    <img src="/assets/img/pet-logo.png" alt="" class="center-block img-responsive" />
                </div>
                <div class="col-md-4 text-center res-margin">
                    <ul class="list-unstyled">
                        <li><i class="fa fa-phone"></i>(000) 000-000</li>
                        <li><i class="fa fa-envelope"></i>Email: <a href="mailto:your@email.com">site@email.com</a></li>
                        <li><i class="fa fa-map-marker"></i>123 Anywhere Street, USA</li>
                    </ul>
                </div>
                <div class="col-md-4 text-center res-margin">
                    <h5>Follow us</h5>
                    <div class="social-media">
                        <a href="#" title=""><i class="fa fa-twitter"></i></a>
                        <a href="#" title=""><i class="fa fa-facebook"></i></a>
                        <a href="#" title=""><i class="fa fa-google-plus"></i></a>
                        <a href="#" title=""><i class="fa fa-instagram"></i></a>
                    </div>
                </div>
            </div>
            <div class="credits col-md-12 text-center">
                Copyright © 2021
                <div class="page-scroll hidden-sm hidden-xs">
                    <a href="#page-top" class="back-to-top"><i class="fa fa-angle-up"></i></a>
                </div>
            </div>
        </footer>
    )
}

export default Footer;